// Порт ref TextFormattingToolbar (SubBlockSettingsEditor:114-188): управляет тем
// редактором, что сейчас в фокусе в канвасе (см. TextEditorContext).
import { Label, cn } from '@teach/ui'
import { segmentedButtonClass } from './segmented'
import { textFormatButtons } from './textFormatButtons'
import { useTextEditor } from '@/features/editor/components/blocks/previews/design/TextEditorContext'
import { useMessages } from '@/i18n'
import { messages } from './messages'

export const TextFormatToolbar = () => {
  const m = useMessages(messages)
  const { activeEditor } = useTextEditor()

  // Пока текст на холсте не в фокусе, кнопкам нечем управлять — панели просто нет
  // (подсказку «кликните на текст» заказчик снял как лишнюю).
  if (!activeEditor) return null

  const buttons = textFormatButtons(activeEditor)

  return (
    <div className="space-y-2">
      <Label className="text-xs text-muted-foreground">{m.formatting}</Label>
      <div className="flex gap-1">
        {buttons.map(({ icon: Icon, label, run, active }) => (
          <button
            key={label}
            type="button"
            title={label}
            onMouseDown={(e) => {
              e.preventDefault()
              e.stopPropagation()
              run()
            }}
            className={cn('flex-1 p-2', segmentedButtonClass(active))}
          >
            <Icon className="mx-auto h-4 w-4" />
          </button>
        ))}
      </div>
      <p className="text-[10px] text-muted-foreground">{m.formattingHint}</p>
    </div>
  )
}
